module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'wxiu7ufb',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
